import { Alert, Button, Divider, Form, Input, message, Typography, Upload } from "antd";
import React, { useState, useEffect } from "react";
import { UploadOutlined } from '@ant-design/icons';
import { apiCall } from "../../utils/Api";
export default function UploadFont(props) {

    const { close = () => { }, save = () => { } } = props;
    const dir = '/web_fonts/';

    const [name, setName] = useState("");

    const uploadFont = (_file) => {

        let ext = _file.file.name.split(".").pop();
        apiCall("files/uploadfont", { file: _file.file, file_name: name + "." + ext }, (_status, _result) => {
            if (_status) {
                message.success("Font uploaded");

                console.log(name + "." + ext)

                save({
                    synthetic: false,
                    name: name + "." + ext,
                    path: "/bm_site_content_fonts/" + name + "." + ext,
                    is_import: false,
                }, true)

                close();
            } else {
                message.error(_result.error)
            }
        })
    }


    return (
        <div style={{ "padding": "20px" }}>
            <Typography.Title level={5}>Upload Font</Typography.Title>
            <Divider style={{ "margin": "15px 0px" }} dashed />
            <Form layout="vertical">
                <Form.Item required label="Font name">
                    <Input onChange={(e) => setName(e.target.value)} value={name} placeholder="Font name..." />
                </Form.Item>
            </Form>
            <Alert message={<small>Only upload .WOFF and .WOFF2 font formats</small>} type="info" />
            <div className="shim" /><div className="shim" /><div className="shim" /><div className="shim" />
            <div className="float-flex">
                <div>&nbsp;</div>
                <div>
                    <Upload accept=".woff, .woff2, .ttf" multiple={false} customRequest={(_file) => uploadFont(_file)}>
                        <Button icon={<UploadOutlined />} disabled={(!name)} type="primary">Upload Font</Button>
                    </Upload>
                </div >
            </div >
        </div>
    )
}